import { render, staticRenderFns } from "./ContratoHome.vue?vue&type=template&id=8b0ba57c"
import script from "./ContratoHome.vue?vue&type=script&lang=js"
export * from "./ContratoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports